// SearchBar.tsx
import React, { useState } from 'react';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import IconButton from '../Buttons/IconButton';

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  onSearch: () => void;
  onClear: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchTerm, setSearchTerm, onSearch, onClear }) => {
  return (
    <div className="flex items-center space-x-4 mb-6 w-full">
      <div className="relative w-full">
        <input
          type="text"
          className="border rounded p-2 w-full pr-10"
          placeholder="Search lab orders..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm on typing
        />
        {searchTerm && (
          <button
            onClick={onClear} // Trigger clear search
            className="absolute right-2 top-1/2 transform -translate-y-1/2 text-[#0870b4] hover:text-[#005c8a]"
          >
            ✖
          </button>
        )}
      </div>
      <IconButton
        icon={<SearchOutlinedIcon />}
        onClick={onSearch} // Trigger search on clicking the icon
      />
    </div>
  );
};

export default SearchBar;
